import { render, staticRenderFns } from "./LoginFormComponent.vue?vue&type=template&id=6cfa9912&scoped=true"
import script from "./LoginFormComponent.vue?vue&type=script&lang=js"
export * from "./LoginFormComponent.vue?vue&type=script&lang=js"
import style0 from "./LoginFormComponent.vue?vue&type=style&index=0&id=6cfa9912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfa9912",
  null
  
)

export default component.exports